import { useAuthToken } from '../store/authTokenStore';

const useIsLoggedIn = () => Boolean(useAuthToken());

export default useIsLoggedIn;
